// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"662":"021fe13e","825":"c5e3bd4b"}[chunkId] + ".chunk.css";
};